import React from 'react'
import parser from 'html-react-parser'

export default function ContentList4({data}) {
    const {contentList4Title, contentList4List} = data
    return (
        <div className='decimal-list-wrap panel-space-80'>
            <div className='container sm-container-1'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h2 className='heading-level-2 blue-color text-center'>
                            {contentList4Title && parser(contentList4Title)}
                        </h2>
                    </div>
                    <div className='col-md-12 yellow-list-content'>
                        {contentList4List?.map((block, i) => {
                            return (
                                <div className='y-content-row' key={i}>
                                    <div className='y-list-number'>{i + 1}.</div>
                                    <div className='y-list-content'>
                                        <div className='heading-level-4-b'>
                                            {block.contentList4ItemTitle && parser(block.contentList4ItemTitle)}
                                        </div>
                                        <p>{block.contentList4ItemText && parser(block.contentList4ItemText)}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
